/**
 * Returns the tenant id embedded in a URL path of the form {@code /app/{id}/...}.
 * Returns {@code null} when the URL has no id segment (generic / pre-login routes).
 *
 * Examples:
 *   /app/mapfre              → 'mapfre'
 *   /app/atos/projects/42    → 'atos'
 *   /app/                    → null
 *   /login                   → null
 *   /                        → null
 */
export function extractTenantIdFromPath(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 2 || segments[0] !== 'app') return null;
  const id = segments[1].trim();
  return id.length > 0 ? id : null;
}

/**
 * Computes the value of {@code APP_BASE_HREF} to use for the current page load.
 * When a tenant id is present in the URL the Angular Router sees every
 * {@code routerLink} as relative to {@code /app/{id}/}, so existing absolute
 * links such as {@code routerLink="/dashboard"} keep working unchanged — they
 * resolve to {@code /app/{id}/dashboard}.
 *
 * Without a tenant id, this returns {@code "/"} so the generic / login routes
 * work as before.
 */
export function computeAppBaseHref(): string {
  const id = extractTenantIdFromPath(window.location.pathname);
  return id ? `/app/${id}/` : '/';
}
